import ProductsFilter from "./ProductsFilter";
import "./MobileProductsFilter.scss";

const MobileProductsFilter = ({
  openBurger,
  closeBurger,
  slug,
  minPrice,
  maxPrice,
  filtersData,
  handleFilterToggle,
  handlePriceChange,
  searchParams,
}: any) => {
  return (
    <nav
      id="Filter-Nav"
      className="Filter-Nav"
      style={{ display: openBurger === true ? "inline" : "none" }}
    >
      <div className="Filter-Nav-Box">
        <div className="Filter-Nav-Box-Title">
          <h2 className="Filter-Title Page-Title">Filteri:</h2>
        </div>
        <div className="Filter-Nav-Box-Items">
          <ProductsFilter
            minPrice={minPrice}
            maxPrice={maxPrice}
            filtersData={filtersData}
            handleFilterToggle={handleFilterToggle}
            handlePriceChange={handlePriceChange}
            searchParams={searchParams}
          />
        </div>
      </div>
    </nav>
  );
};
export default MobileProductsFilter;
